import { isNotNullish } from '@airreading/common';
import { Table } from '@tanstack/react-table';
import { useCallback, useMemo, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrentRowSelectionCount = (table: Table<any>) => table.getFilteredSelectedRowModel().rows.length;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearCurrentRowSelection = (table: Table<any>) => table.toggleAllPageRowsSelected(false);

interface UseBulkSelectionProps<TData> {
  getRowId: (row: TData) => string;
  rowIdToData: (id: string) => TData | undefined;
}

export const useRowsBulkSelection = <TData>({ getRowId, rowIdToData }: UseBulkSelectionProps<TData>) => {
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({});

  const rowDataSelection = useMemo(() => {
    return Object.keys(rowSelection).flatMap((id) => {
      const result = rowIdToData(id);
      return isNotNullish(result) ? [result] : [];
    });
  }, [rowSelection, rowIdToData]);

  const resetAllRowSelection = useCallback(() => {
    setRowSelection({});
  }, []);

  return {
    getRowId,

    /**
     * The selected row Ids
     */
    rowSelection,

    /**
     * The selected row objects
     */
    rowDataSelection,
    onRowSelectionChange: setRowSelection,
    resetAllRowSelection,
  };
};
